module.exports = __webpack_public_path__ + "static/media/NR.2c22d18e.png";